export default {
    url: '/review/developmentplan',
    template: '<review-development-plan/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/review/developmentplan/index.js